'use strict';

import { ConfigurationRequest } from './ConfigurationRequest';
import { DomainContext } from '../../../../parametrage/DomainContext';

class ColorThemeRequest extends ConfigurationRequest {
    constructor(domain: DomainContext, _id? : string){
        super('theme', domain, _id);
    }
}

export { ColorThemeRequest };